<template>
  <b-navbar type="dark" :sticky="true" class="px-3">
    <div class="left d-flex align-items-center">
      <b-btn
        id="admin-sidebar-collapse"
        variant="link"
        class="p-2"
        v-if="isAuthenticatedUserHasAccess"
        @click="toggleSidebar"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          fill="currentColor"
          class="bi bi-list"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
          />
        </svg>
      </b-btn>
      <router-link :to="{ name: 'ProjectIndex' }" class="d-flex logos">
        <b-img
          src="/images/logo-mynd.svg"
          alt="Mynd"
          width="110"
          class="ml-4"
        ></b-img>
        <svg width="1" height="40" class="ml-4" v-if="realmSettings && realmSettings.clientLogoUrl">
          <line x1="1" y1="1" x2="1" y2="40" stroke="#333333" stroke-width="1"></line>
        </svg>
        <b-img
           v-if="realmSettings && realmSettings.clientLogoUrl"
          :src="realmSettings.clientLogoUrl"
          alt="Rousselot"
          class="ml-4 client-logo"
        ></b-img>
      </router-link>
      <div class="ml-3 px-2 small d-flex" v-if="$route.meta.explore">
        [<a class="text-fix cursor-pointer" @click="openTopicModal"> {{ modelTopic ? "Topic: " + modelTopic : 'Define Topic' }} </a>]
      </div>
    </div>

    <div v-if="isAuthenticatedUserHasAccess" class="middle">
      <b-navbar-nav v-if="$route.meta.explore">
        <b-nav-item
          :active="$route.name === 'ExploreFields'"
          :to="{ name: 'ExploreFields' }"
          >Fields</b-nav-item
        >
        <b-nav-item
          :active="$route.name === 'ExploreStory'"
          :to="{ name: 'ExploreStory' }"
          >Story</b-nav-item
        >
        <b-nav-item
          :active="$route.name === 'ExploreDiscover'"
          :to="{ name: 'ExploreDiscover' }"
          >Discover</b-nav-item
        >
        <b-nav-item
          :active="$route.name === 'ExploreAnalysisIndex'"
          :to="{ name: 'ExploreAnalysisIndex' }"
          >Analysis</b-nav-item
        >
        <!--<b-nav-item
          :active="$route.name === 'ExploreFilters'"
          :to="{ name: 'ExploreFilters' }"
          >Filters</b-nav-item
        >-->
      </b-navbar-nav>
    </div>

    <div class="right">
      <div class="cb-buttons ml-auto">
        <!-- <b-btn class="chatbot ml-auto mr--0 notification-button" variant="outline-transparent" 
        @click="notifyConfirmation"
        :class="{active:notifyStatus}"
        :aria-pressed="notifyStatus"
        >
          Notify <i class="fa fa-bell"></i>
           <span 
            class="badge"
            v-if="notifyStatus"
           ></span>
        </b-btn> -->
        <b-btn class="chatbot ml-auto mr-0" variant="outline-transparent" @click="toggleSupportPanel">
          Support <i class="fa fa-life-ring"></i>
        </b-btn>
        <b-btn v-if="$route.meta.explore" class="chatbot ml-auto mr-0" variant="outline-transparent" @click="startChatbot" :disabled="chatbotReady === 1">
          <template v-if="chatbotReady === 0">
            Initiate MyndSparX <img src="/images/sparks.png" alt="Mynd - Sparks" />
          </template>
          <template v-else-if="chatbotReady === 1">
            <b-progress :max="totalIndexingDocs">
              <b-progress-bar :value="processedIndexingDocs" :label="`${((processedIndexingDocs / totalIndexingDocs) * 100).toFixed(2) > 100 ? 100 : ((processedIndexingDocs / totalIndexingDocs) * 100).toFixed(2)}%`" show-progress animated></b-progress-bar>
            </b-progress>
          </template>
          <template v-else-if="currentThread">
            Resume MyndSparX <img src="/images/sparks-on.png" alt="Mynd - Sparks" />
          </template>
          <template v-else>
            Ask MyndSparX <img src="/images/sparks-on.png" alt="Mynd - Sparks" />
          </template>
        </b-btn>
        <!--<b-btn v-if="$route.meta.explore && chatbotReady === 2" rel="Delete Indexing" class="hidden-button" size="sm" variant="outline-transparent" @click="deleteIndexing">
          <i class="fa fa-times"></i> Delete Indexing
        </b-btn>-->
      </div>
      <b-navbar-nav>
        <b-nav-item-dropdown right>
          <template slot="button-content">
            <div class="nav-user">
              <div class="avatar">{{ authenticatedUserFullName? authenticatedUserFullName[0]:"?" }}</div>
              <div v-if="!authenticatedUserFullName" class="blob red"></div>
            </div>
          </template>
          <b-dropdown-item @click="changeRole" v-if="authenticatedUserBaseRole==='normal'">
            Switch to {{ isAuthenticatedUserHasAccess? "Viewer":"Normal" }}
          </b-dropdown-item>
          <b-dropdown-item
          :to="{ name: 'UserEdit', params: { id: authenticatedUserId }}"
          >
            Update profile <span v-if="!authenticatedUserFullName" class="blob red"></span> 
          </b-dropdown-item>
          <b-dropdown-item
            v-if="$route.meta.explore"
            :active="$route.name === 'ExploreSettings'"
            :to="{ name: 'ExploreSettings' }"
            >Settings</b-dropdown-item
          >
          <b-dropdown-item
            v-if="$route.meta.explore"
            :active="$route.name === 'Export'"
            :to="{ name: 'Export' }"
            >Export</b-dropdown-item
          >
          <b-dropdown-item
            v-if="showManageAccountLink"
            :href="manageAccountUrl"
            target="_blank"
            >Manage account</b-dropdown-item
          >
          <b-dropdown-item
            v-if="['admin','mynd','usman'].includes(authenticatedUserName)"
            :to="{ name: 'Errors' }"
            >Errors Log</b-dropdown-item
          >
          <!--<b-dropdown-item
            v-if="['admin','mynd','usman'].includes(authenticatedUserName) && $route.meta.explore"
            @click="deleteIndexing"
            >Reset MyndSpraX</b-dropdown-item
          >-->
          <b-dropdown-item
            v-if="['admin','mynd','usman'].includes(authenticatedUserName)"
            :to="{ name: 'ManageLimits' }"
            >Manage limits</b-dropdown-item
          >
          <b-dropdown-item
            v-if="['admin','mynd','usman'].includes(authenticatedUserName)"
            :to="{ name: 'ManageAccess' }"
            >Manage Access</b-dropdown-item
          >
          <b-dropdown-item @click="notifyConfirmation">{{ notifyStatus ? "Disable Notification" : "Enable Notification" }}</b-dropdown-item>
          <b-dropdown-item @click="logout">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-btn v-if="$route.meta.explore && isAuthenticatedUserHasAccess" class="navbar-drawer" @click="toggleExploreSidebar">
        <template v-if="filterSidebarState">
          <i class="fas fa-filter" :class="{'fa-hourglass-start': classificationStatus && stats.status<5}"></i><i class="fa fa-angle-double-right"></i>
        </template>
        <template v-else>
          <i class="fa fa-angle-double-left"></i><i class="fas fa-filter" :class="{'fa-hourglass-start': classificationStatus && stats.status<5}"></i>
        </template>
      </b-btn>
    </div>
    <!-- Support panel -->
    <div v-if="showSupportPanel" class="support-panel" @click.stop>
      <div class="support-panel-header">
        <div>
          <div class="title">Support</div>
          <div class="tagline">Quick help — send us a screenshot and description</div>
        </div>
        <button class="close" @click="toggleSupportPanel">&times;</button>
      </div>
      <form class="support-form" @submit.prevent="submitSupport">
        <div class="form-group">
          <label class="small">Select section</label>
          <select v-model="support.section" class="form-control form-control-sm">
            <option value="Project management">Project management</option>
            <option value="Model calculation">Model Calculation</option>
            <option value="Fields">Fields</option>
            <option value="Story">Story</option>
            <option value="Discover">Discover</option>
            <option value="Filter">Filter</option>
            <option value="Auto Classification">Auto Classification</option>
            <option value="Myndsparks">Myndsparks</option>
            <option value="Analysis">Analysis</option>
          </select>
        </div>
        <div class="form-group">
          <label class="small">Add description</label>
          <textarea v-model="support.description" rows="3" class="form-control form-control-sm" placeholder="Describe the issue..."></textarea>
        </div>
        <div class="form-group">
          <label class="small">Select gravity</label>
          <select v-model="support.gravity" class="form-control form-control-sm">
            <option value="1">Bug/Blocker</option>
            <option value="2">Disturbance</option>
            <option value="3">UI/UX Improvement</option>
            <option value="4">Suggestion</option>
            <option value="5">Other</option>
          </select>
        </div>
        <div class="form-group" v-if="!uploading">
          <label class="small">Attach screenshot</label>
          <div class="custom-file-wrapper">
            <input ref="fileInput" type="file" @change="onFileChange" accept="image/*" style="display: none;"/>
            <button type="button" class="btn btn-light btn-sm" @click="$refs.fileInput.click()">
              Choose File
            </button>
            <span class="file-label">
              {{uploadedFileName  || "No file chosen" }}
            </span>
            <!-- <p v-if="uploadedFileName" class="text-success mt-2">
              
            </p> -->
          </div>
        </div>
        <div v-else class="small text-muted">Uploading file...</div>
        <div class="disclaimer small text-muted">Please Describe the issue clearly; our team will review and respond.</div>
        <div class="d-flex justify-content-end mt-2">
          <b-btn type="submit" variant="primary" size="sm" class="mr-2">Submit</b-btn>
          <b-btn variant="link" size="sm" @click="toggleSupportPanel">Cancel</b-btn>
        </div>
      </form>
    </div>

    <!-- Topic Modal for entering topic if missing -->
    <TopicModal ref="topicModal" />
  </b-navbar>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import ApiRequest from "@/helpers/ApiRequest";
import { mapActions, mapGetters, mapState } from "vuex";
import TopicModal from '../Explore/Shared/TopicModal';

export default {
  name: "Navbar",
  components: {
    TopicModal
  },
  data() {
    return {
      totalIndexingDocs: 0,
      processedIndexingDocs: 0,
      showConfirmDelete: false,
      showSupportPanel: false,
      support: {
        section: 'Project management',
        description: '',
        gravity: '1',
        attachment: null
      },
      uploading: false,
      filetype: null,
      uploadedFileName: "",
      finalFileName: "",
      fileExtension: "",
      notficationEnabled:false
    };
  },
  computed: {
    ...mapGetters(["authenticatedUserId", "authenticatedUserBaseRole","isAuthenticatedUserHasAccess", "authenticatedUserName", "authenticatedUserFullName", "modelTopic","notifyStatus"]),
    ...mapState({
      apiId: (state) => state.api.apiId,
      currentModelName: (state) => state.api.currentModelName,
      currentProjectName: (state) => state.api.currentProjectName,
      realmSettings: (state) => state.setting.realmSettings,
      filterSidebarState: (state) => state.layout.filterSidebarState,
      chatbotReady: (state) => state.chatbot.chatbotReady,
      chatbotState: (state) => state.chatbot.chatbotState,
      notifyStatus: (state) => state.admin.notifyStatus,
      currentThread: (state) => state.chatbot.currentThread,
      classificationStatus: (state) => state.classification.classificationStatus,
      stats: (state) => state.classification.stats
    }),
    showManageAccountLink() {
      return Vue.prototype.$globalSettings.auth_provider === "keycloak";
    },
    manageAccountUrl() {
      return (
        Vue.prototype.$globalSettings.url +
        "realms/" +
        Vue.prototype.$authService.realm +
        "/account/"
      );
    },
  },
  methods: {
    ...mapActions(["saveFilterSidebarState", "toggleChatBotState", "initiateChatbot", "resetChatbot", "chatbotStatus", "setChatbotStatus", "updateUserRole", "reportErrors","updateNotifyStatus"]),
    logout() {
      Vue.prototype.$authService.logout();
    },
    toggleSidebar() {
      this.$emit("toggleSidebar");
    },
    startChatbot() {
      if(this.chatbotReady === 0){
        this.setChatbotStatus(1);
        this.initiateChatbot({model_id : this.apiId}).then(() => {
          this.$toasted.show("Indexing started for selected model", {
            type: "warning",
          });
          let cb = setInterval(() => {
            this.chatbotStatus({model_id : this.apiId}).then(res => {
              this.totalIndexingDocs = res.processed+res.unprocessed;
              this.processedIndexingDocs = res.processed;
              if(res.processing_state === 2){
                clearInterval(cb);
                this.setChatbotStatus(2);
              }
            })
          }, 5000)
        });  
      }
      else{
        this.toggleChatBotState();
      }
    },
    toggleSupportPanel() {
      this.showSupportPanel = !this.showSupportPanel;
    },
    onFileChange(e) {
      if (!this.validateFile(e.target.files[0])) {
        this.$toasted.show("Invalid file type. Please upload an image or PDF.", {
          type: "error",
        });
        return;
      }
      this.uploading = true;
      const jwt = localStorage.getItem("jwt") || "";
      const f = e.target.files && e.target.files[0];
      this.support.attachment = f || null;
      this.filetype = f.type;
      
      // Sanitize filename: remove spaces, unwanted chars, and add timestamp
      const fileNameParts = this.support.attachment.name.split(".");
      this.fileExtension = fileNameParts.pop();
      
      const baseName = fileNameParts.join(".");
      this.finalFileName = baseName
        .replace(/\s+/g, '_')  // Replace spaces with underscores
        .replace(/[^a-zA-Z0-9_-]/g, '')  // Remove unwanted characters, keep alphanumeric, underscore, and hyphen
        .toLowerCase();
      const timestamp = Date.now();
      // this.finalFileName = `${sanitizedName}`;
      this.uploadedFileName = this.support.attachment.name;
      
      axios
        .get(
          Vue.prototype.$globalSettings.api_endpoint +
            "/generate_bucket_url?file_name=" +
            this.finalFileName + "&file_type=" +
            this.filetype,
          {
            headers: {
              Authorization: "Bearer " + jwt,
              "Requested-Data-Source": "project"
            }
          }
        )
        .then(res => {
          const url = res.data.url;
          const fields = res.data.fields;
          const formData = new FormData();
          formData.append("key", fields["key"]);
          formData.append("policy", fields["policy"]);
          formData.append("x-amz-algorithm", fields["x-amz-algorithm"]);
          formData.append("x-amz-credential", fields["x-amz-credential"]);
          formData.append("x-amz-date", fields["x-amz-date"]);
          formData.append("x-amz-meta-filetype", this.filetype);
          formData.append("x-amz-meta-user", this.authenticatedUserName);
          formData.append("x-amz-signature", fields["x-amz-signature"]);
          formData.append("file", this.support.attachment); // Make sure file is appended last to prevent errors
          ApiRequest.customPost(url, formData).then(res => {
            console.log(res);
            // this.support.attachment = null;
            this.uploading = false;
            if (res !== null && res.status === 204) {
              console.log(fileNameParts)
                this.$toasted.show("File uploaded!", {
                  type: "success"
                });
            } else {
              this.$toasted.show("File upload Failure", { type: "error" });
            }
          });
        })
        .catch(response => {
          this.file = null;
          this.uploading = false;
          //this.$toasted.show(response, { type: "error" });
        });
    },
    validateFile(file) {
      //console.log(this.filetype, file)
      if (
        ![
          "application/pdf",
          "image/png",
          "image/jpeg",
          "image/jpg",
          "image/bmp",
          "image/tiff",
          "image/gif",
        ].includes(file.type)
      ) {
        this.support.attachment = null;
        return false;
      }
      else {
        return true;
      }
    },
    submitSupport() {
      // For now just log/notify — wiring to backend can be added later
      try {
        const payload = {
          section: this.support.section,
          description: this.support.description,
          gravity: this.support.gravity,
          filename: this.support.attachment ? this.finalFileName + "." + this.fileExtension : null,
        };
        console.log('Support submit:', payload);
        this.reportErrors(payload).then(() => {
          // Reset form
          this.support.section = 'Project management';
          this.support.description = '';
          this.support.gravity = 1;
          this.support.attachment = null;
          this.$toasted.show('Support request submitted', { type: 'success' });
          this.uploadedFileName = null;
        });
      } catch (e) {
        console.error(e);
      }
      this.toggleSupportPanel();
    },
    async notifyConfirmation(){
      const newStatus = !this.notifyStatus;
      const payload = {
        status: newStatus ? "YES": "NO"
      }
      const textMessage = newStatus ? 
        "Enable email notifications for the completion of PoolProcessing, ModelCalculation, and AutoFiltering tasks?"
        : "Disable email notifications for the completion of PoolProcessing, ModelCalculation, and AutoFiltering tasks?";
      try{
        this.$bvModal
          .msgBoxConfirm(
            textMessage,
            this.$confirmOptions
          ).then((value) => {
            if(value) {
              let typeMessage = newStatus ? "success" : "error";
              this.updateNotifyStatus(payload).then( () =>{
              this.$toasted.show(
                newStatus ? "Email Notification Enabled."
                : "Email Notification Disabled."
                ,{
                  type: `${typeMessage}`,
              });
            });
          }
      });
        
      } catch (e){
        console.error(e)
        this.notifyStatus = !this.notifyStatus;
        this.$toasted.show(
          "Failed to update notification. Please try again",
          {type:"error"}
        );
      }
    },
    deleteIndexing(){
      if(this.showConfirmDelete){
        this.resetChatbot({model_id : this.apiId}).then(() => {
          this.setChatbotStatus(0);
          if(this.chatbotState){
            this.toggleChatBotState();
          }
          this.$toasted.show("indexing cleared for selected model", {
            type: "success",
          });
        });
      }
      else{
        this.toggleConfirmDelete();
      }
    },
    toggleConfirmDelete() {
      this.showConfirmDelete = !this.showConfirmDelete;
    },
    toggleExploreSidebar() {
      this.saveFilterSidebarState(!this.filterSidebarState);
    },
    changeRole() {
      let newRole = this.isAuthenticatedUserHasAccess ? "discover" : "normal";
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to switch to ${newRole} role?`,
          {
            title: "Change Role",
            size: "md",
            buttonSize: "md",
            okVariant: "primary",
            okTitle: "Yes",
            cancelTitle: "No",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.updateUserRole(newRole).then(() => {
              localStorage.setItem("userRole", newRole);
              window.location.reload();
            });
          }
        });
    },
    openTopicModal() {
      this.$refs.topicModal.show(this.modelTopic || "");
    },
  },
};
</script>

<style scoped>
  .custom-file-wrapper{
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .file-label{
    font-size: 14px;
    color: #333;
  }
  .notification-button{
    position: relative;
    padding: 10px;
    cursor: pointer;
  }
  .notification-button .badge {
    position: absolute;
    top: 4px;
    right: 4px;
    background-color: #fa3e3e; /* Red color */
    color: white;
    border-radius: 50%; /* Makes it a circle */
    width: 8px;
    height: 8px;
    padding: 3px 6px;
    font-size: 10px;
}
.notification-button.active i{
  color: #1d72f3;
}
</style>